import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-select-table-limit",
  template: `<label class="d-flex align-items-center">
    <span>{{ "SHOW" | translate }}</span>
    <select class="form-control ml-075 pr-3" #tableLimit (change)="handlerChange(tableLimit.value)">
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select>
  </label>`,
})
export class SelectTableLimitComponent {
  @Input() limits: number[] = [10, 25, 50, 100];
  @Input() label: string = "SHOW";
  @Input() defaultValue: number = 10;
  @Output() onChange = new EventEmitter<number>();

  handlerChange(value: string | number) {
    this.onChange.emit(Number(value));
  }
}
